import { FC, ReactElement } from 'react';

import {
    LinkButton,
    Picture,
    Section,
    ThemeTitle,
} from '../../../components';
import { PageCallToActionInterface } from '../../../entities/@sections/PageCallToAction/PageCallToAction';
import useResponsiveImages from '../../../hooks/useResponsiveImages';

import './MobileHighlightedPage.scss';

interface MobileHighlightedPageProps extends PageCallToActionInterface {
    className?: string;
}

const MobileHighlightedPage: FC<MobileHighlightedPageProps> = ({
    titleHtml,
    paragraph,
    image,
    responsiveImages,
    link,
    className = '',
}): ReactElement => {
    const imageList = image ? [image] : [];
    const responsiveImageList = useResponsiveImages(imageList, responsiveImages);

    const backgroundImage = responsiveImageList.length > 0
        ? responsiveImageList[0]
        : undefined;

    return (
        <Section isDark className={`mobile-highlighted-page ${className}`}>
            <div className="mobile-highlighted-page__text-wrapper">
                <ThemeTitle
                    titleHtml={titleHtml}
                    className="mobile-highlighted-page__title"
                />

                <p className="mobile-highlighted-page__description">
                    {paragraph}
                </p>

                {link && (
                    <LinkButton
                        to={link.path}
                        text={link.label}
                        className="mobile-highlighted-page__link-button"
                    />
                )}
            </div>

            {backgroundImage && (
                <Picture
                    {...backgroundImage.image}
                    objectPosition={backgroundImage.position}
                    className="mobile-highlighted-page__picture"
                    imageClassName="mobile-highlighted-page__image"
                />
            )}
        </Section>
    );
};

export default MobileHighlightedPage;
